module.exports = __webpack_public_path__ + "img/GODIVA.22a70577.png";